import { render } from "./PaymentOptionModal.vue?vue&type=template&id=ecb1c2b2&scoped=true"
import script from "./PaymentOptionModal.vue?vue&type=script&lang=js"
export * from "./PaymentOptionModal.vue?vue&type=script&lang=js"

import "./PaymentOptionModal.vue?vue&type=style&index=0&id=ecb1c2b2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecb1c2b2"]])

export default __exports__